export default {"src":"/_next/static/media/arrowUp.f3308aab.svg","height":22,"width":22};